import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IncomeReceiptsService } from '../../../services/income-receipts.service';
import { ToastService } from '../../../services/toast.service';

@Component({
    selector: 'app-pending-approvals',
    templateUrl: './pending-approvals.component.html',
    styleUrl: './pending-approvals.component.scss'
})
export class PendingApprovalsComponent implements OnInit {
    receipts: any[] = [];
    isLoading = true;
    loadError = false;

    // Modal de aprobación/rechazo
    showApprovalConfirmationModal = false;
    selectedReceipt: any = null;
    approvalAction: string = '';
    approvalNotes: string = '';
    isProcessingApproval = false;

    constructor(
        private incomeReceiptsService: IncomeReceiptsService,
        private toastService: ToastService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.loadPendingApprovals();
    }

    loadPendingApprovals(): void {
        this.isLoading = true;
        this.loadError = false;

        this.incomeReceiptsService.getPendingApprovals().subscribe({
            next: (response: any) => {
                this.receipts = response.data || [];
                this.isLoading = false;
            },
            error: (error: any) => {
                console.error('Error loading pending approvals:', error);
                this.loadError = true;
                this.isLoading = false;
            }
        });
    }

    viewDetails(receipt: any): void {
        this.router.navigate(['/income-receipts/view', receipt.id]);
    }

    showApprovalModal(receipt: any, action: string): void {
        this.selectedReceipt = receipt;
        this.approvalAction = action;
        this.approvalNotes = '';
        this.showApprovalConfirmationModal = true;
    }

    onCancelApproval(): void {
        this.showApprovalConfirmationModal = false;
        this.selectedReceipt = null;
        this.approvalAction = '';
        this.approvalNotes = '';
    }

    onConfirmApproval(): void {
        if (!this.selectedReceipt || !this.approvalAction) return;
        if (this.approvalAction === 'Reject' && !this.approvalNotes.trim()) return;

        this.isProcessingApproval = true;

        this.incomeReceiptsService.processApproval(
            this.selectedReceipt.id,
            this.approvalAction,
            this.approvalNotes.trim()
        ).subscribe({
            next: () => {
                const actionLabel = this.approvalAction === 'Approve' ? 'aprobada' : 'rechazada';
                this.toastService.showToast('success', `Edición ${actionLabel} exitosamente`);
                this.isProcessingApproval = false;
                this.showApprovalConfirmationModal = false;
                this.selectedReceipt = null;
                this.approvalNotes = '';
                this.loadPendingApprovals();
            },
            error: (error: any) => {
                console.error('Error processing approval:', error);
                this.toastService.showToast('error', 'Error al procesar la aprobación');
                this.isProcessingApproval = false;
            }
        });
    }

    formatCurrency(amount: number): string {
        if (!amount && amount !== 0) return '$0.00';
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    }

    getPayerName(receipt: any): string {
        if (receipt.payerDisplayName) return receipt.payerDisplayName;
        if (receipt.participant) {
            return `${receipt.participant.firstName || ''} ${receipt.participant.lastName || ''}`.trim();
        }
        if (receipt.companyName) return receipt.companyName;
        return 'N/A';
    }

    getPayerDocument(receipt: any): string {
        if (receipt.participant) {
            return `${receipt.participant.typeDocument || ''} ${receipt.participant.documentId || ''}`.trim();
        }
        return '';
    }

    getTimeAgo(dateStr: string): string {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const now = new Date();
        const diffMs = now.getTime() - date.getTime();
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMins / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffMins < 1) return 'hace un momento';
        if (diffMins < 60) return `hace ${diffMins} min`;
        if (diffHours < 24) return `hace ${diffHours}h`;
        if (diffDays === 1) return 'hace 1 día';
        return `hace ${diffDays} días`;
    }
}
